import React, { Component } from 'react';
import { Button, } from 'semantic-ui-react'
import axios from 'axios'
import { pythonApiIp } from '../../../../config/constants'


import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

class LargeProjectsNav extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    enterNewCustomer = () => {
        history.push("/dashboard/enterLargeCustomer");
    }

    enterNewProject = () => {
        history.push("/dashboard/enterLargeProject");
    }

    //  paidThisMonth = () => {
    //     history.push("/dashboard/largeProjectsHome/paid_this_month");
    // }

    viewCommission = () => {
        history.push("/dashboard/ViewThisMonthCommission");
    }

    showUnpaid = () => {
        history.push("/dashboard/ViewDeliveredUnpaid");
    }

    // enterProjectCosts = () => {
    //     history.push("/dashboard/enterProjectCosts");
    // }

    home = () => {
        history.push("/dashboard/largeProjectsHome");
    }

    searchNow = () => {
        history.push("/dashboard/ProjectsSearchNow");
    }

    showDocs = () => {
        history.push("/dashboard/viewLargeProjectDocuments");
    }

    syncWithAlogolia = () => {
        console.log("+++++++ syncWithAlogolia +++++")

        axios.post(pythonApiIp + 'syncProjectsAlgolia', {
            apiKey: "APODFASF@dDFDD",
        })
            .then((response) => {

                console.log(response.data);

                if (response.data.result) {
                    console.log("true.. project marked as payNow");

                    alert(response.data.message);
                    //history.push("/dashboard/viewLargeProject/" + this.props.projectId);
                } else {
                    console.log("FAILED");
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });
    }

    render() {

        const commButton = this.props.showCommissionButton
            ? <Button color='violet' onClick={this.viewCommission}> View Comm </Button>
            : ''

        const showUnpaidButton = this.props.showUnpaidButoon
            ? <Button color='black' onClick={this.showUnpaid}> Show Unpaid</Button>
            : ''

        const showSyncWithAlogolia = this.props.syncWithAlogolia
            ? <Button color='orange' onClick={this.syncWithAlogolia}> Sync Algolia</Button>
            : ''

        const showDocsButton = this.props.showUnpaidButoon
            ? <Button color='violet' onClick={this.showDocs}> Show Docs</Button>
            : ''

        return (

            <div>
                <Button color='red' onClick={this.home}> Home</Button>
                <Button color='purple' onClick={this.searchNow}>SearchNow </Button>
                <Button color='teal' onClick={this.enterNewCustomer}> Enter New Customer </Button>
                <Button color='blue' onClick={this.enterNewProject}> Enter New Project </Button>
                {commButton}
                {showUnpaidButton}
                {showSyncWithAlogolia}
                {showDocsButton}


                {/* <Button color='orange'  onClick={this.enterProjectCosts}> Add Project Costs</Button> */}
            </div>
        );
    }
}

export default LargeProjectsNav;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/LargeProjectsNav.js